export const FRESH_BRANCH_PREFIX = 'fresh-';

export type BranchType = 'hypermarket' | 'fresh';

export function isFreshBranchSlug(slug: string | null | undefined): boolean {
	return !!slug?.startsWith(FRESH_BRANCH_PREFIX);
}

export function getBranchType(slug: string | null | undefined): BranchType {
	return isFreshBranchSlug(slug) ? 'fresh' : 'hypermarket';
}

export function getBranchStoryblokRoot(slug: string): string {
	const folder = isFreshBranchSlug(slug) ? '_fresh-pobocky' : '_pobocky';

	return `_globus-cz/${folder}/${slug}`;
}

export function getBranchStoryblokSlug(slug: string, relativePath = ''): string {
	const normalizedRelativePath = relativePath.replace(/^\/+/, '').replace(/\/+$/, '');
	const root = getBranchStoryblokRoot(slug);

	return normalizedRelativePath.length ? `${root}/${normalizedRelativePath}` : root;
}
